import * as React from "react";
import { Container, Row, Col } from "react-bootstrap";
import styled from "styled-components";
import { RichText, RichTextReact } from "wmk-rich-text";
import { BlockTitleText } from "../../../../fragments/blockTitleTextFields";
import { mq } from "../../../../vars/mediaQueries";
import { colors } from "../../../../vars/palette";
import { options } from "../richTextOptions";

const OneTwoWrap = styled(Container)`
  padding: 2rem 0rem;
  ${mq.max("sm", "padding: 2rem 1rem 0rem 1rem;")}
  .row > * {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  h1,
  h2 {
    color: ${colors.hex("secondary")};
    &.h2r {
      text-align: right;
      font-size: 2.5rem;
      ${mq.max(
        "sm",
        `text-align: left;
        font-size: 2rem;`
      )}
    }
  }
  a {
    color: ${colors.hover("secondary")};
    transition: all 0.3s ease;
    &:hover {
      color: ${colors.hex("primary")};
      transition: all 0.3s ease;
    }
  }
`;

export const TitleText = (props: BlockTitleText) => {
  const { layout, richText, title } = props;
  const content = new RichText(richText);
  const rowClass = layout === "Stacked" ? "flex-column" : undefined;

  return (
    <OneTwoWrap>
      <Row className={rowClass}>
        <Col sm={12} md={layout === "Stacked" ? 12 : 4}>
          {title === "A Boutique Marketing Agency" ? (
            <h1 className="h2r">{title}</h1>
          ) : (
            <h1>{title}</h1>
          )}
        </Col>
        <Col sm={12} md={layout === "Stacked" ? 12 : 8}>
          <RichTextReact content={content} options={options} />
        </Col>
      </Row>
    </OneTwoWrap>
  );
};
